
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/bollettino-neve-commenti",
      function () {
        return require("private-next-pages/[region]/[resort]/bollettino-neve-commenti.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/bollettino-neve-commenti"])
      });
    }
  